export default __webpack_public_path__ + "static/media/email_svg.bdfc73c3.svg";